import React from "react"
import { Link } from "@material-ui/core"

const LinkButton = ({ children, className, ...rest }) => (
  <Link
    component="button"
    className={`OpLinkButton-root${className ? ` ${className}` : ""}`}
    underline="none"
    {...rest}
  >
    {children}
  </Link>
)

export { LinkButton }
